var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnCountryCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4295_19571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48056 4.69531C1.53796 5.9217 0.827189 7.33522 0.41333 8.8708H6.65605L2.48056 4.69531Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5866 8.87075C23.1728 7.33522 22.4619 5.9217 21.5194 4.69531L17.344 8.87075H23.5866Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.41333 15.1328C0.827236 16.6683 1.538 18.0819 2.48056 19.3082L6.65591 15.1328H0.41333Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3058 2.48134C18.0794 1.53873 16.6659 0.827969 15.1304 0.414062V6.65673L19.3058 2.48134Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69409 21.5191C5.92048 22.4617 7.334 23.1725 8.86953 23.5864V17.3438L4.69409 21.5191Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86948 0.414062C7.33395 0.827969 5.92044 1.53873 4.69409 2.4813L8.86948 6.65669V0.414062Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 23.5864C16.6659 23.1725 18.0794 22.4617 19.3058 21.5191L15.1304 17.3438V23.5864Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.344 15.1328L21.5194 19.3082C22.4619 18.0819 23.1728 16.6683 23.5866 15.1328H17.344Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 15.129L20.4852 20.4838C20.7315 20.2376 20.9664 19.9802 21.1906 19.7134L16.6061 15.1289H15.1304V15.129Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86951 15.1289H8.86941L3.51465 20.4837C3.76084 20.73 4.01823 20.9649 4.28504 21.189L8.86951 16.6045V15.1289Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86951 8.87058V8.87048L3.5147 3.51562C3.26842 3.76181 3.03348 4.0192 2.80933 4.28602L7.39384 8.87053L8.86951 8.87058Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 8.86883L20.4852 3.51392C20.239 3.26764 19.9817 3.0327 19.7148 2.80859L15.1304 7.39311V8.86883Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4295_19571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnCountryCode);
export default __webpack_public_path__ + "static/media/ENCountryCode.90e6706c177bd838296456f9e9c56c6d.svg";
export { ForwardRef as ReactComponent };